import React, { useState, useEffect, createContext, useContext } from "react";
import "../../styles/pages/home/Home.scss";
import FormPage from "./FormPage";
import PreviewPage from "./PreviewPage";
import ThankYouPage from "./ThankYouPage";
import WaitingListPage from "./WaitingListPage";
import EndPage from "./EndPage";
import { Trans, useTranslation } from "react-i18next";
import { GlobalContext } from "../../App";

export const HomeContext = createContext();

function Home() {
  const { t, i18n } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [isPreview, setIsPreview] = useState(false);
  const [isWaitingList, setIsWaitingList] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState("");
  const [haveWorkshopCode, setHaveWorkshopCode] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Assuming mobile width is less than 768px

  const queryParameters = new URLSearchParams(window.location.search);

  const { infoData } = useContext(GlobalContext);

  useEffect(() => {
    if (queryParameters.get("workshop_detail_id")) {
      setHaveWorkshopCode(true);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const dataValue = {
    currentStep,
    setCurrentStep,
    setIsPreview,
    submitErrorMessage,
    setSubmitErrorMessage,
    isWaitingList,
    setIsWaitingList,
    haveWorkshopCode,
    setHaveWorkshopCode,
  };

  return (
    <HomeContext.Provider value={dataValue}>
      <div className="banner">
        <img src={i18n.language === "hk" ? infoData.desktop_tc_img : infoData.desktop_en_img} style={{ width: "100%", display: isMobile ? "none" : "block" }} />
        <img src={i18n.language === "hk" ? infoData.mobile_tc_img : infoData.mobile_en_img} style={{ width: "100%", display: isMobile ? "block" : "none" }} />
      </div>
      <div className="page-container">
        <div className="title">{Object.keys(infoData).length === 0 ? <></> : i18n.language === "hk" ? <span>{infoData.title_tc}</span> : <span>{infoData.title_eng}</span>}</div>

        {currentStep === 0 ? (
          <>
            <div className={isPreview ? "hide" : "show"}>
              <FormPage />
            </div>
            <div className={isPreview ? "show" : "hide"}>
              <PreviewPage />
            </div>
          </>
        ) : currentStep === 1 ? (
          <ThankYouPage />
        ) : currentStep === 2 ? (
          <WaitingListPage />
        ) : currentStep === 3 ? (
          <EndPage />
        ) : (
          <></>
        )}
      </div>
    </HomeContext.Provider>
  );
}

export default Home;
